// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-wrap button:disabled.button-style-7[data-v-175d5354]{\n    background: transparent;\n    border: 1px solid #707070;\n}\n.button-wrap button:disabled.button-style-7 > span[data-v-175d5354]{\n    color: #707070;\n}\n.account_good[data-v-175d5354] {\n  color: rgb(27, 185, 27);\n  font-size: 12px;\n  line-height: 1;\n  margin-left: auto;\n  margin-top: 5px;\n}\n.form-input.form-input-error-1 input[data-v-175d5354]:not(.inp-left) {\n  border: 1px solid #FF0000;\n}\n", ""]);
// Exports
module.exports = exports;
